export default context => {
    const moduleId = context.getters.moduleId;

    const payloadComplainant = {
        key: 'complainant',
        value: {
            firstName: context.rootState[`${moduleId}_complaint-submission_first-name`].value,
            lastName: context.rootState[`${moduleId}_complaint-submission_last-name`].value,
            language: context.rootState[`${moduleId}_complaint-submission_language`].value,
            phone: context.rootState[`${moduleId}_complaint-submission_phone`].phoneNumber,
            email: context.rootState[`${moduleId}_complaint-submission_email`].value,
            address1: context.rootState[`${moduleId}_complaint-submission_address`].address1,
            address2: context.rootState[`${moduleId}_complaint-submission_address`].address2,
            city: context.rootState[`${moduleId}_complaint-submission_address`].city,
            county: context.rootState[`${moduleId}_complaint-submission_address`].county,
            state: context.rootState[`${moduleId}_complaint-submission_address`].state,
            zipCode: context.rootState[`${moduleId}_complaint-submission_address`].zip,
            role: context.rootState[`${moduleId}_complaint-submission_role`].value,
        },
    };
    const payloadComplaint = {
        key: 'complaint',
        value: {
            description: context.rootState[`${moduleId}_additional-questions_describe-text_input-text`].value,
        },
    };
    const payloadRespondent = {
        key: 'respondent',
        value: {
            name: context.rootState[`${moduleId}_employer_name`].value,
            address1: context.rootState[`${moduleId}_employer_address`].address1,
            address2: context.rootState[`${moduleId}_employer_address`].address2,
            city: context.rootState[`${moduleId}_employer_address`].city,
            county: context.rootState[`${moduleId}_employer_address`].county,
            state: context.rootState[`${moduleId}_employer_address`].state,
            zipCode: context.rootState[`${moduleId}_employer_address`].zip,
            phone: context.rootState[`${moduleId}_employer_phone`].phoneNumber,
            email: context.rootState[`${moduleId}_employer_email`].value,
            contactFirstName: context.rootState[`${moduleId}_employer_business-contact-first-name`].value,
            contactLastName: context.rootState[`${moduleId}_employer_business-contact-last-name`].value,
            contactPhone: context.rootState[`${moduleId}_employer_business-contact-phone`].phoneNumber,
            contactEmail: context.rootState[`${moduleId}_employer_business-contact-email`].value,
        },
    };
    const payloadAllegations = {
        key: 'allegations',
        value: context.rootState[`${moduleId}_allegations_checklist`].value || [],
    };
    const payloadAdditionalQuestions = {
        key: 'additionalQuestions',
        value: {
            dateStartWork: context.rootState[`${moduleId}_additional-questions_date-start-work`].value,
            dateEndWork: context.rootState[`${moduleId}_additional-questions_date-end-work`].value,
            dateStartComplaint: context.rootState[`${moduleId}_additional-questions_date-start-complaint`].value,
            dateEndComplaint: context.rootState[`${moduleId}_additional-questions_date-end-complaint`].value,
        },
    };

    context.commit('appState/SET_VALUE', payloadComplainant, { root: true });
    context.commit('appState/SET_VALUE', payloadComplaint, { root: true });
    context.commit('appState/SET_VALUE', payloadRespondent, { root: true });
    context.commit('appState/SET_VALUE', payloadAllegations, { root: true });
    context.commit('appState/SET_VALUE', payloadAdditionalQuestions, { root: true });
};